export default {
    brand: {
        product_name: 'FleetHub24',
        tagline:      'Prikupljanje s uređaja',
    },
    nav: {
        map:           'Karta',
        vehicles:      'Vozila',
        drivers:       'Vozači',
        costs:         'Troškovi',
        trips:         'Vožnje',
        stats:         'Statistika',
        zones:         'Područja',
        alerts:        'Upozorenja',
        reminders:     'Podsjetnici',
        reports:       'Izvješća',
        install_guide: 'Upute za ugradnju',
        configuration: 'Postavke',
        settings:      'Račun i korisnici',
        collapse:      'Skupi izbornik',
        expand:        'Proširi izbornik',
        version_web:   'Konzola {version}',
        version_api:   'API {version}',
        organizations: 'Organizacije',
        service:        'Servis',
        out_of_service: 'Vozila izvan pogona',
        service_cases:  'Servisni nalozi',
        assigned_cases: 'Dodijeljeni nalozi',
        part_orders:    'Narudžbe dijelova',
    },
    general: {
        add:      'Dodaj',
        edit:     'Uredi',
        cancel:   'Odustani',
        save:     'Spremi',
        close:    'Zatvori',
        refresh:  'Osvježi',
        filter:   'Filtar',
        search:   'Pretraga',
        loading:  'Učitavanje …',
        copy:     'Kopiraj',
        copied:   'Kopirano',
        none:     '—',
        settings: 'Postavke',
        confirm:  'Potvrdi',
        delete:   'Obriši',
        sign_out: 'Odjava',
    },
    auth: {
        login:     'Prijava',
        username:  'Korisničko ime',
        password:  'Lozinka',
        sign_in:   'Prijavi se',
        failed:    'Prijava nije uspjela',
        signed_in: 'Prijavljeni ste kao {name}',
        or:            'ili',
        password_show: 'Prikaži lozinku',
        password_hide: 'Sakrij lozinku',
    },
    settings: {
        settings:    'Postavke',
        subtitle:    'Vaš račun, ljudi koji mogu otvoriti ovu konzolu i ključevi kojima se prijavljujete.',
        account:     'Račun',
        reader_note: 'Prijavljeni ste kao čitatelj: u konzoli vidite sve, ali ništa ne možete mijenjati. Promjene radi administrator.',
    },
    password: {
        change:        'Promijeni lozinku',
        current:       'Trenutna lozinka',
        new:           'Nova lozinka',
        repeat:        'Ponovite novu lozinku',
        mismatch:      'Lozinke se ne podudaraju',
        wrong_current: 'Trenutna lozinka nije točna',
        changed:       'Lozinka je promijenjena',
        failed:        'Lozinku nije bilo moguće promijeniti',
    },
    user: {
        users:              'Korisnici',
        subtitle:           'Svi koji mogu otvoriti ovu konzolu.',
        add:                'Dodaj korisnika',
        edit:               'Uredi korisnika',
        delete:             'Obriši korisnika',
        name:               'Ime',
        username:           'Korisničko ime',
        role:               'Uloga',
        role_admin:         'Administrator',
        role_reader:        'Čitatelj',
        role_help:          'Čitatelj sve vidi i ništa ne mijenja; administrator uz to uređuje vozila i upravlja korisnicima.',
        created:            'Stvoren',
        password:           'Lozinka',
        password_optional:  'Nova lozinka',
        password_rule:      'Najmanje 12 znakova. Napadača košta duljina, a ne brojke i posebni znakovi.',
        password_keep:      'Ostavite prazno ako lozinku ne mijenjate.',
        password_too_short: 'Lozinka mora imati najmanje 12 znakova',
        username_too_short: 'Najmanje 3 znaka',
        name_too_long:      'Najviše 64 znaka',
        username_taken:     'To korisničko ime već je zauzeto',
        last_admin:         'Posljednjeg administratora nije moguće obrisati ni pretvoriti u čitatelja',
        cannot_delete_self: 'Vlastiti račun ne možete obrisati',
        confirm_delete:     'Obrisati račun korisnika {name}? S njim odlaze i njegovi ključevi za prijavu.',
        deleted:            'Račun je obrisan',
        delete_failed:      'Račun nije bilo moguće obrisati',
        empty:              'Još nema nijednog računa.',
        you:                'vi',
        organization:      'Organizacija',
        organization_help: 'Organizacija kojoj račun pripada odlučuje što vidi; uloga odlučuje što smije mijenjati.',
    },
    organization: {
        organizations:   'Organizacije',
        subtitle:        'Operater, klijenti čije flote održava i servisi koji ih popravljaju.',
        add:             'Dodaj organizaciju',
        edit:            'Uredi organizaciju',
        kind:            'Vrsta',
        all_kinds:       'Sve vrste',
        search:          'Traži po nazivu, OIB-u ili gradu',
        empty:           'Nema organizacija.',
        inactive:        'neaktivna',
        name:            'Naziv',
        customer_type:   'Vrsta flote',
        tax_id:          'OIB',
        address:         'Adresa',
        city:            'Grad',
        country:         'Država',
        country_help:    'Dvoslovna oznaka, npr. HR',
        lat:             'Geografska širina',
        lon:             'Geografska dužina',
        contact:         'Kontakt',
        contact_email:   'Kontakt e-pošta',
        contact_phone:   'Kontakt telefon',
        active:          'Aktivna',
        active_help:     'Neaktivna organizacija ostaje sačuvana, ali njezini se korisnici više ne mogu prijaviti.',
        kind_operator:   'Operater',
        kind_customer:   'Klijent',
        kind_workshop:   'Servis',
        type_rent_a_car: 'Rent-a-car',
        type_transport:  'Prijevoz',
        type_machinery:  'Strojevi',
        type_other:      'Ostalo',
        switcher:        'Klijent u prikazu',
        all_customers:   'Sve stranke',
    },
    portal: {
        operator: 'Stanić — upravljanje',
        customer: 'Flota — klijenti',
        workshop: 'Servis — partneri',
    },
    passkey: {
        passkeys:       'Ključevi za prijavu',
        subtitle:       'Ključevi kojima se prijavljujete — telefon, prijenosnik, hardverski ključ.',
        add:            'Dodaj ključ',
        continue:       'Dalje',
        delete:         'Ukloni ključ',
        name:           'Ime',
        name_help:      'Nazovite ga po uređaju na kojem se nalazi, da kasnije znate koji ukloniti.',
        name_too_long:  'Najviše 60 znakova',
        default_name:   'Ovaj uređaj',
        created:        'Dodan',
        last_used:      'Zadnji put upotrijebljen',
        never_used:     'još neupotrijebljen',
        added:          'Ključ je dodan',
        removed:        'Ključ je uklonjen',
        failed:         'Ključ nije bilo moguće dodati',
        delete_failed:  'Ključ nije bilo moguće ukloniti',
        confirm_delete: 'Ukloniti ključ „{name}“? Njime se više nećete moći prijaviti.',
        empty:          'Još nemate ključ za prijavu.',
        sign_in:        'Prijava ključem',
        sign_in_failed: 'Taj ključ nije prihvaćen',
        unavailable:    'Ključevi za prijavu nisu uključeni na ovoj instalaciji — treba im vlastita domena preko HTTPS-a.',
        unsupported:    'Ovaj preglednik ne podržava ključeve za prijavu. Treba im sigurna veza (HTTPS).',
    },
    service_key: {
        keys:             'API ključevi',
        subtitle:         'Ključevi kojima se drugi sustavi prijavljuju u konzolu — prije svega korporativni portal. Svaki ključ ima administratorska prava.',
        add:              'Novi ključ',
        add_help:         'Nazovite ga po sustavu koji će ga koristiti, da kasnije znate koji opozvati.',
        name:             'Naziv',
        name_placeholder: 'Portal',
        name_too_long:    'Najviše 64 znaka',
        create:           'Izradi ključ',
        prefix:           'Početak ključa',
        created:          'Izrađen',
        last_used:        'Zadnje korišten',
        never_used:       'još nije korišten',
        status:           'Stanje',
        active:           'Aktivan',
        revoked:          'Opozvan',
        environment:      'Iz okruženja',
        environment_name: 'Ključ {n} iz okruženja',
        environment_note: 'Ključevi iz okruženja zapisani su u varijabli SERVICE_API_KEYS u datoteci /opt/stanic-fleet/.env na poslužitelju. Ovdje ih nije moguće opozvati — uklonite ih iz te datoteke i ponovno objavite stanic-api.',
        revoke:           'Opozovi',
        revoke_title:     'Opoziv ključa',
        revoke_confirm:   'Opozovi ključ',
        confirm_revoke:   'Opozvati ključ „{name}” ({prefix}…)? Sustav koji ga koristi više se neće moći prijaviti s njim. Opoziv nije moguće poništiti.',
        revoked_toast:    'Ključ je opozvan',
        revoke_failed:    'Ključ nije bilo moguće opozvati',
        created_toast:    'Ključ je izrađen',
        create_failed:    'Ključ nije bilo moguće izraditi',
        empty:            'API ključeva još nema.',
        result_title:     'Novi API ključ: {name}',
        result_once:      'Ključ se prikazuje samo sada',
        result_warning:   'Kopirajte ga i spremite u sustav koji će ga koristiti. Kasnije ga više neće biti moguće vidjeti — ako ga izgubite, opozovite ga i izradite novi.',
        result_usage:     'Authorization: Bearer <ključ>',
        done:             'Ključ je spremljen, zatvori',
    },
    layout: {
        open_menu:  'Otvori izbornik',
        close_menu: 'Zatvori izbornik',
    },
    color_mode: {
        switch_to_light: 'Prebaci na svijetli način',
        switch_to_dark:  'Prebaci na tamni način',
    },
    density: {
        label:   'Gustoća prikaza',
        compact: 'Zbijen',
        normal:  'Normalan',
    },
    locale: {
        label: 'Jezik',
        en:    'Engleski',
        sl:    'Slovenski',
        hr:    'Hrvatski',
    },
    errors: {
        generic_error: 'Došlo je do greške',
        invalid_data:  'Neispravni podaci',
        not_found:     'Nije pronađeno',
        unauthorized:  'Nemate pristup',
        forbidden:     'Radnja nije dopuštena',
        on_add:        'Greška pri dodavanju',
        on_edit:       'Greška pri spremanju',
        on_load:       'Podatke nije bilo moguće učitati',
    },
    success: {
        add:  'Uspješno dodano',
        edit: 'Uspješno spremljeno',
    },
    validation: {
        required: 'Ovo polje je obavezno',
    },
    time: {
        now:     'sada',
        never:   'nikad',
        minutes: '{count} min',
        hours:   '{count} h',
        days:    '{count} dana',
        ago:     'prije {value}',
    },
    device: {
        devices:        'Uređaji',
        device:         'Uređaj',
        imei:           'IMEI',
        state:          'Stanje',
        online:         'Povezan',
        offline:        'Nije povezan',
        first_seen:     'Prvi put viđen',
        last_seen:      'Zadnji put viđen',
        last_record:    'Zadnji zapis',
        last_position:  'Zadnji položaj',
        last_speed:     'Zadnja brzina',
        record_count:   'Zapisi',
        packet_count:   'Paketi',
        counts:         'Zapisi / paketi',
        empty_title:    'Nijedan uređaj se još nije javio',
        empty_body:     'Poslužitelj sluša na TCP portu 5027 (Codec 8 Extended). Uređaj se pojavljuje ovdje čim pošalje prvi paket — najprije se predstavi IMEI-jem, zatim šalje zapise.',
        not_found:      'Nema uređaja s tim IMEI-jem',
        auto_refresh:   'Automatsko osvježavanje',
        refresh_every:  'Osvježava se svakih {seconds} s',
        waiting:        'Čeka',
        waiting_title:  'Čeka svoj prvi paket',
        waiting_body:   'Vozilo je upisano, a njegov se uređaj još nije javio. Čim pošalje prvi paket, ovdje će se pojaviti vremena, položaj i parametri — do tada nema što prikazati.',
        asleep:         'spava',
        sleep_none:     'bez spavanja',
        sleep_gps:      'GPS spavanje',
        sleep_deep:     'duboko spavanje',
        sleep_online:   'spavanje na vezi',
        sleep_ultra:    'ultra spavanje',
    },
    driver: {
        drivers:              'Vozači',
        subtitle:             'Popis vozača koje navode knjiga vožnji i dodjele vozila.',
        add:                  'Dodaj vozača',
        edit:                 'Uredi vozača',
        name:                 'Ime i prezime',
        phone:                'Telefon',
        email:                'E-pošta',
        employee_no:          'Br. zaposlenika',
        tag:                  'Oznaka privjeska',
        tag_help:             'Za kasnije automatsko prepoznavanje vozača (iButton, RFID ili Bluetooth privjesak). Zasad se ne koristi.',
        note:                 'Napomena',
        active:               'Aktivan',
        inactive:             'Neaktivan',
        show_inactive:        'Prikaži neaktivne',
        search:               'Traži po imenu, telefonu ili broju zaposlenika …',
        vehicles:             'Vozila',
        empty:                'Nema vozača.',
        unknown:              'Nepoznat vozač',
        delete:               'Izbriši vozača',
        confirm_delete:       'Želiš li stvarno izbrisati vozača {name}?',
        confirm_keeps:        'Vozač ima povijest vožnji pa će biti deaktiviran, a ne izbrisan.',
        deleted:              'Vozač je uklonjen s popisa.',
        delete_failed:        'Vozača nije bilo moguće izbrisati',
        tag_taken:            'Ta oznaka privjeska već je dodijeljena drugom vozaču.',
        name_too_long:        'Najviše 80 znakova',
        phone_invalid:        'Upiši telefonski broj — znamenke, razmaci i + - / ( ).',
        email_invalid:        'Upiši ispravnu adresu e-pošte.',
        employee_no_too_long: 'Najviše 32 znaka',
        tag_too_long:         'Najviše 64 znaka',
        note_too_long:        'Najviše 200 znakova',
    },
    vehicle: {
        photo_pick:     'Učitaj fotografiju',
        photo_clear:    'Ukloni fotografiju',
        photo_drop:     'Povuci fotografiju ovdje ili je odaberi — JPEG, PNG ili WebP',
        photo_failed:   'Fotografiju nije bilo moguće spremiti',
        drivetrain:      'Pogon',
        drivetrain_auto: 'Utvrdi iz podataka',
        drivetrain_ice:  'Motor s unutarnjim izgaranjem',
        drivetrain_ev:   'Električno',
        drivetrain_phev: 'Plug-in hibrid',
        drivetrain_help: 'Kod vozila koje već šalje ostavi prvu opciju — ono što uređaj šalje govori više od sjećanja.',
        vehicle:        'Vozilo',
        edit:           'Uredi vozilo',
        name:           'Naziv',
        plate:          'Registarska oznaka',
        body:           'Karoserija',
        colour:         'Boja',
        colour_help:    'Odaberite jednu od boja ili upišite heksadecimalnu vrijednost.',
        colour_invalid: 'Upišite heksadecimalnu boju, primjerice #1e4fa3',
        name_too_long:  'Najviše 64 znaka',
        plate_too_long: 'Najviše 16 znakova',
        add:                  'Dodaj vozilo',
        added:                'Vozilo je dodano.',
        add_failed:           'Vozilo nije bilo moguće dodati',
        imei:                 'IMEI uređaja',
        imei_help:            'Petnaest znamenki s naljepnice na uređaju; isti IMEI pokazuje i Teltonika Configurator.',
        imei_length:          'IMEI ima 15 znamenki.',
        imei_invalid:         'IMEI nije valjan — provjeri zadnju znamenku.',
        imei_exists:          'Vozilo s tim IMEI-jem već postoji.',
        imei_authorises:      'Time dopuštaš uređaju s tim IMEI-jem da se poveže.',
        name_required:        'Upiši naziv vozila.',
        delete:               'Izbriši vozilo',
        delete_blocks:        'Uređaj ovog vozila više se neće moći povezati.',
        delete_keeps:         'Podaci ostaju spremljeni; dodaš li vozilo s istim IMEI-jem ponovno, opet će se prikazati.',
        delete_purge:         'Izbriši i sve podatke ovog vozila (zapise, putanje, knjigu vožnji, upozorenja). To nije moguće poništiti.',
        delete_confirm_plate: 'Za potvrdu upiši registarsku oznaku.',
        delete_confirm_imei:  'Za potvrdu upiši zadnjih šest znamenki IMEI-ja.',
        deleted:              'Vozilo je izbrisano.',
        delete_failed:        'Vozilo nije bilo moguće izbrisati',
        empty_add:            'Dodaj vozilo i time dopusti njegovom uređaju da se poveže.',
        driver:                'Vozač',
        no_driver:             'Bez vozača',
        assign_driver:         'Dodijeli vozača',
        driver_since:          'Vrijedi od',
        driver_since_now:      'Od sada',
        driver_since_choose:   'Odaberi drugo vrijeme',
        driver_assigned:       'Vozač je dodijeljen.',
        driver_failed:         'Vozača nije bilo moguće dodijeliti',
        driver_history:        'Povijest vozača',
        driver_history_empty:  'Ovo vozilo još nije imalo dodijeljenog vozača.',
        driver_from:           'od {from}',
        driver_to:             'do {to}',
        driver_now:            'sada',
        driver_show_all:       'Prikaži sve',
        driver_show_less:      'Prikaži manje',
        purchase_value:     'Nabavna vrijednost (s PDV-om)',
        purchase_help:      'Koliko je vozilo stajalo s PDV-om — to je osnovica za bonitetu. Kod najma vrijednost vlasnika, kod rabljenog vozila ono što je tvrtka doista platila.',
        purchase_currency:  'Valuta',
        first_use:          'Datum prve uporabe',
        first_use_help:     'Dan kada je poslodavac vozilo stekao — ne dan prve registracije. Od njega se broji godišnje umanjenje.',
        employer_fuel:      'Poslodavac plaća gorivo za privatne vožnje',
        employer_fuel_help: 'Boniteta se tada povećava za četvrtinu.',
        benefit_user:       'Korisnik vozila',
        benefit_user_help:  'Zaposlenik koji vozilo ima za privatnu uporabu. Prazno znači trenutačno dodijeljenog vozača.',
        fuel_type:          'Vrsta goriva',
        fuel_type_none:     'Nije određeno',
        fuel_petrol:        'Benzin',
        fuel_diesel:        'Dizel',
        fuel_lpg:           'Plin (LPG)',
        fuel_electric:      'Električno',
        fuel_hybrid:        'Hibrid',
        fuel_phev:          'Priključni hibrid',
        finance:            'Financije',
        finance_help:       'Vidljivo samo administratorima. Prazna polja ne mijenjaju ništa.',
        finance_saved:      'Financijski podaci su spremljeni.',
        customer:          'Klijent',
        customer_help:     'Čijoj floti vozilo pripada. Vide ga samo ljudi tog klijenta.',
        customer_pick:     'Odaberite klijenta',
        customer_required: 'Odaberite klijenta',
        no_customer:       'Bez klijenta',
        move_in_service:   'Vozilo ima otvoren servisni nalog. Zatvorite ili otkažite nalog prije premještanja vozila drugom klijentu.',
    },
    tracker: {
        model:            'Uređaj za praćenje',
        model_help:       'Koji je Teltonika uređaj u vozilu — o njemu ovisi što znači koja vrijednost. Bez odabira čita se kao FMC003.',
        unknown:          'Nije zabilježen (čita se kao FMC003)',
        line:             'Uređaj: {model} · {family}',
        family_obd:       'OBD utikač',
        family_light_can: 'Laka vozila (CAN)',
        family_heavy:     'Kamioni i strojevi (FMS)',
        engine_hours:     'Motorni sati',
        hours_unit:       'h',
    },
    body: {
        unknown:   'Nije određeno',
        sedan:     'Limuzina',
        estate:    'Karavan',
        hatchback: 'Hatchback',
        suv:       'SUV',
        van:       'Kombi',
        pickup:    'Pickup',
        truck:     'Kamion',
    },
    tab: {
        map:        'Karta',
        parameters: 'Parametri',
        records:    'Zapisi',
        packets:    'Sirovi paketi',
        graphs:     'Grafikoni',
    },
    graph: {
        speed:        'Brzina u odnosu na ograničenje',
        rpm:          'Okretaji motora',
        temperatures: 'Temperature',
        battery:      'Baterija',
        fuel:         'Gorivo',
        consumption:  'Potrošnja',
        power:        'Snaga baterije',
        level:        'Razina',
        average_consumption: 'Prosječna potrošnja',
        limit:        'Upisano ograničenje',
        over_limit:   'Prekoračenje',
        charging:     'Punjenje',
        empty:        'U ovom razdoblju nema zapisa.',
        not_reported: 'Vozilo ne šalje ove vrijednosti: {names}.',
        window_fit:   'Prilagodi vožnjama',
        window_all:   'Prikaži cijelo razdoblje',
        window_fitted: 'prilagođeno vožnjama',
        window_earlier: 'Pomakni natrag',
        window_later: 'Pomakni naprijed',
        window_hint:  'Povuci za povećanje, kotačić za približavanje, Home za cjelinu.',
    },
    fleet_map: {
        title:            'Karta',
        all:              'Sva',
        driving:          'U vožnji',
        stopped:          'Stoje',
        asleep:           'Spavaju',
        offline:          'Bez signala',
        alerting:         'S upozorenjem',
        search:           'Traži po nazivu, tablici, IMEI-ju ili mjestu …',
        badge_moving:     'Vozi',
        badge_stopped:    'Stoji',
        badge_asleep:     'Spava',
        badge_offline:    'Bez signala',
        badge_never_seen: 'Nije viđeno',
        state_moving:     'Vozi {duration}',
        state_stopped:    'Stoji {duration}',
        state_asleep:     'Spava {duration}',
        state_offline:    'Bez signala {duration}',
        state_never_seen: 'Još nije viđeno',
        over_a_day:       'Više od 24 h',
        days:             '{count} dan | {count} dana | {count} dana',
        open:             'Otvori',
        fit:              'Prilagodi svim vozilima',
        refreshed:        'zadnje osvježavanje {ago}',
        empty:            'Nema vozila koja odgovaraju filtru.',
        no_positions:     'Nijedno vozilo još nema poznat položaj.',
        hide_list:        'Sakrij popis',
        show_list:        'Prikaži popis',
        unsupported:      'Ova inačica API-ja još ne poznaje kartu flote. Sve ostalo u konzoli radi kao prije.',
        to_vehicles:      'Otvori popis vozila',
        driver:           'Vozač',
        centre_selected: 'Centriraj odabrano vozilo',
        live_routes:     'Prikaži putanje vozila u vožnji',
        drive_distance:  'Putanja ove vožnje: {km} km',
    },
    logbook: {
        title:               'Knjiga vožnji',
        business:            'Službena',
        private:             'Privatna',
        unclassified:        'Nerazvrstana',
        kind:                'Vrsta vožnje',
        purpose:             'Svrha vožnje',
        driver:              'Vozač',
        odometer:            'Stanje brojača',
        tracker_odometer:    'brojač uređaja, ne vozila',
        gps_distance:        'Izmjerena udaljenost: {km} km',
        edit:                'Uredi unos',
        edit_trip:           'Uredi unos za vožnju {route}',
        saved:               'Spremljeno',
        save_failed:         'Unos nije bilo moguće spremiti.',
        keep:                'Ne mijenjaj',
        bulk_title:          'Označi odabrane vožnje',
        bulk_help:           'Prazna polja ostavljaju postojeće unose na miru.',
        select:              'Odaberi vožnju',
        select_day:          'Odaberi cijeli dan',
        selected:            'Odabrano: {count}',
        mark_business:       'Označi kao službene',
        mark_private:        'Označi kao privatne',
        set_purpose:         'Svrha…',
        clear_selection:     'Poništi odabir',
        export:              'Izvezi CSV',
        export_failed:       'Izvoz nije bilo moguće pripremiti.',
        filter:              'Vrsta vožnje',
        all_kinds:           'Sve',
        filter_business:     'Službene',
        filter_private:      'Privatne',
        filter_unclassified: 'Nerazvrstane',
        totals:              'službeno {business} km · privatno {private} km · nerazvrstano {unclassified} km',
        threshold_note:      'Knjiga vožnji vrijedi uz prag od 30 min; uz drugi prag razvrstavanje nije moguće.',
        purpose_too_long:    'Svrha vožnje je predugačka.',
        driver_too_long:     'Ime vozača je predugačko.',
        from_assignment:     'po dodjeli',
        driver_filter:       'Vozač',
        all_drivers:         'Svi vozači',
        driver_pick:         'Odaberi vozača ili upiši ime',
        driver_help:         'Odaberi vozača s popisa ili upiši ime vanjskog vozača.',
    },
    trips_page: {
        title:        'Vožnje',
        period:       'Razdoblje',
        today:        'Danas',
        yesterday:    'Jučer',
        last_7:       'Zadnjih 7 dana',
        last_30:      'Zadnjih 30 dana',
        custom:       'Prilagođeno',
        range:        'Od–do',
        vehicles:     'Vozila',
        all_vehicles: 'Sva vozila',
        stop_label:   'Vožnja završava nakon',
        totals:       'Ukupno: {trips} vožnji · {km} km · {time} vožnje',
        day_totals:   '{trips} vožnji · {km} km · {time}',
        empty:        'U odabranom razdoblju nema vožnji.',
        select_trip:  'Odaberi vožnju da je vidiš na karti.',
        open_vehicle: 'Otvori vozilo',
        fold_all:     'Sažmi sve',
        unfold_all:   'Proširi sve',
        fold_day:     'Sažmi dan {day}',
        unfold_day:   'Proširi dan {day}',
    },
    gps: {
        latitude:   'Zemljopisna širina',
        longitude:  'Zemljopisna dužina',
        altitude:   'Nadmorska visina',
        angle:      'Smjer',
        satellites: 'Sateliti',
        speed:      'Brzina',
        valid:      'Važeća pozicija',
        invalid:    'Bez pozicije',
        no_fix:     'Uređaj još nije poslao važeću poziciju.',
    },
    track: {
        title:               'Trag',
        period:              'Razdoblje',
        last_hour:           'Zadnji sat',
        last_day:            'Zadnjih 24 h',
        last_week:           'Zadnjih 7 dana',
        points:              'Točaka: {count}',
        empty:               'U odabranom razdoblju nema važećih pozicija.',
        attribution:         '© Suradnici OpenStreetMapa',
        attribution_tomtom:  '© TomTom',
        attribution_traffic: 'Promet © TomTom',
        zoom:                'Zumiranje {zoom}',
        zoom_in:             'Približi',
        zoom_out:            'Udalji',
        fit:                 'Prilagodi tragu',
        centre_vehicle:      'Centriraj vozilo',
        traffic:             'Promet',
        traffic_legend:      'Sloj prometa boji svaku cestu prema tome koliko tečno se vozi — zelena teče, narančasta usporava, crvena puzi, tamnocrvena stoji. Osvježava se svake dvije minute.',
        speed_chart:         'Brzina',
        chart_show:          'Prikaži graf brzine',
        chart_hide:          'Sakrij graf brzine',
    },
    cost: {
        title:             'Troškovi',
        add:               'Dodaj trošak',
        edit:              'Uredi trošak',
        added:             'Trošak je dodan.',
        saved:             'Trošak je spremljen.',
        deleted:           'Trošak je izbrisan.',
        save_failed:       'Trošak nije bilo moguće spremiti',
        delete_failed:     'Trošak nije bilo moguće izbrisati',
        delete_confirm:    'Izbrisati ovaj trošak? Priloženi račun ide s njim.',
        empty:             'U odabranom razdoblju nema troškova.',
        export:            'Izvezi CSV',
        export_failed:     'Izvoz nije bilo moguće pripremiti',
        cat_fuel:          'Gorivo',
        cat_charging:      'Punjenje',
        cat_service:       'Servis',
        cat_tyres:         'Gume',
        cat_insurance:     'Osiguranje',
        cat_registration:  'Registracija',
        cat_vignette:      'Vinjeta',
        cat_toll:          'Cestarina',
        cat_parking:       'Parking',
        cat_wash:          'Pranje',
        cat_fine:          'Kazna',
        cat_leasing:       'Leasing',
        cat_other:         'Ostalo',
        tab_costs:         'Troškovi',
        tab_overview:      'Pregled',
        period:            'Razdoblje',
        range:             'Razdoblje po mjeri',
        this_month:        'Ovaj mjesec',
        last_month:        'Prošli mjesec',
        this_year:         'Ove godine',
        last_12:           'Zadnjih 12 mjeseci',
        custom:            'Po mjeri',
        all_vehicles:      'Sva vozila',
        all_categories:    'Sve kategorije',
        all_drivers:       'Svi vozači',
        vehicle:           'Vozilo',
        date:              'Datum',
        category:          'Kategorija',
        amount:            'Iznos',
        currency:          'Valuta',
        vat_rate:          'Stopa PDV-a',
        vat_none:          'Nije navedena',
        quantity:          'Količina',
        unit:              'Jedinica',
        unit_price:        'Cijena po jedinici',
        full_tank:         'Pun spremnik',
        full_tank_help:    'Potrošnja se pošteno može izmjeriti samo između dva puna spremnika — ono što uđe između njih točno je ono što je potrošeno.',
        odometer:          'Stanje brojača',
        odometer_help:     'Predloženo je ono što je vozilo javilo tog dana. Možeš ispraviti.',
        odometer_unknown:  'Vozilo tog dana nije javilo stanje brojača.',
        supplier:          'Dobavljač',
        document_no:       'Br. računa',
        note:              'Napomena',
        driver:            'Vozač',
        receipt:           'Račun (prilog)',
        receipt_pick:      'Učitaj račun',
        receipt_open:      'Otvori račun',
        receipt_clear:     'Ukloni račun',
        receipt_drop:      'Povuci račun ovamo ili ga odaberi — JPEG, PNG, WebP ili PDF, do 5 MB',
        receipt_failed:    'Račun nije bilo moguće spremiti',
        receipt_saved:     'Račun je priložen.',
        receipt_removed:   'Račun je uklonjen.',
        receipt_after:     'Račun možeš priložiti kad je trošak spremljen.',
        load_older:        'Učitaj starije',
        total:             'Ukupno',
        records:           'zapisa: {count}',
        mixed_currency:    'Troškovi su u različitim valutama; ova konzola ih ne preračunava, pa je ukupni iznos samo zbroj brojeva.',
        overview:          'Pregled',
        by_month:          'Po mjesecima',
        per_km:            'Trošak po km',
        consumption:       'Potrošnja',
        consumption_approx: 'Približno — električno vozilo nije moguće mjeriti između dva puna punjenja, pa je ovo sva energija na prijeđene kilometre.',
        km_driven:         'Prijeđeni km',
        km_odometer:       'po brojaču vozila',
        km_trips:          'po GPS udaljenosti vožnji',
        km_unknown:        'Vozilo nije javilo prijeđene kilometre, pa trošak po kilometru nije moguće izračunati.',
        no_data:           'Za ovaj pregled nema podataka.',
        amount_invalid:    'Upiši iznos, na primjer 45,90',
        amount_ambiguous:  'Iznos nije moguće pročitati — 1,234 može biti 1,234 ili 1234. Napiši 1234,00 ili 1,23.',
        quantity_invalid:  'Upiši količinu, na primjer 41,37',
        quantity_required: 'Kod goriva i punjenja količina je obavezna.',
        vehicle_required:  'Odaberi vozilo.',
        from_reminder:     'iz podsjetnika',
        open_reminders:    'Otvori podsjetnike vozila',
    },
    stats: {
        title:                'Statistika',
        export:               'Izvezi CSV',
        export_failed:        'Izvoz nije bilo moguće pripremiti',
        failed:               'Statistiku nije bilo moguće učitati.',
        period:               'Razdoblje',
        range:                'Prilagođeno razdoblje',
        this_month:           'Ovaj mjesec',
        last_month:           'Prošli mjesec',
        last_7:               'Zadnjih 7 dana',
        last_30:              'Zadnjih 30 dana',
        custom:               'Prilagođeno',
        all_vehicles:         'Sva vozila',
        vehicles:             'Vozila',
        all_drivers:          'Svi vozači',
        driver_filter:        'Vozač',
        speeding_check:       'Provjeri prekoračenja brzine',
        window_note:          'Statistika obuhvaća najviše {days} dana: vožnje se pri svakom pregledu ponovno izračunavaju iz zapisa lokacije, pa je razdoblje ograničeno kao na stranici Vožnje.',
        window_clamped:       'Odabrano razdoblje dulje je od {days} dana, pa je prikazano zadnjih {days} dana.',
        tab_vehicles:         'Po vozilu',
        tab_drivers:          'Po vozaču',
        tab_days:             'Po danima',
        drives:               'Vožnje',
        drives_count:         '{count} vožnja | {count} vožnje | {count} vožnji',
        no_drives:            'bez vožnji',
        vehicles_moved:       'vozila u pokretu: {moved} od {vehicles}',
        km:                   'Kilometri',
        km_split:             'službeno {business} · privatno {private} · nerazvrstano {unclassified}',
        business_km:          'Službeno km',
        private_km:           'Privatno km',
        unclassified_km:      'Nerazvrstano km',
        driving_time:         'Vrijeme vožnje',
        days_in_window:       '{days} dan u razdoblju | {days} dana u razdoblju | {days} dana u razdoblju',
        costs:                'Troškovi',
        costs_note:           'iz registra troškova za dane razdoblja',
        no_costs:             'u razdoblju nema upisanih troškova',
        cost_per_km:          'Trošak po km',
        per_km_fleet:         'vozila s poznatim prijeđenim kilometrima',
        per_km_driver:        'po kilometrima koje je prešao vozač',
        truncated:            'Vozilo je u ovom razdoblju poslalo više zapisa nego što se može pročitati odjednom, pa najstarije vožnje nedostaju. Odaberi kraće razdoblje.',
        speeding_unavailable: 'Ograničenja brzine nije bilo moguće dobiti, pa prekoračenja nisu provjerena.',
        speeding_found:       'Prekoračenja brzine: {events} u {checked} od {drives} vožnji.',
        speeding_stopped:     'Za sljedeću vožnju ograničenja nisu bila dostupna, pa je provjera zaustavljena.',
        speeding_capped:      'Provjera je ograničena po upitu; za ostale vožnje odaberi kraće razdoblje ili jedno vozilo.',
        speeding_partial:     'Provjereno {checked} od {drives} vožnji',
        speeding_footnote:    'Prekoračenje su barem dva uzastopna zapisa iznad ograničenja za više od {tolerance} km/h — GPS trag uspoređen s kartom, a ne dokaz.',
        footnote:             'Kilometri su prema brojaču vozila gdje ga je vozilo javilo, inače prema GPS udaljenosti. Vožnja se broji na dan kad je počela; nedovršena vožnja se ne broji. Prosječna brzina računa se bez zaustavljanja tijekom vožnje.',
        sort_by:              'Poredaj po: {column}',
        empty:                'Za odabrano razdoblje nema podataka.',
        vehicle:              'Vozilo',
        driver:               'Vozač',
        no_driver:            'Bez vozača',
        external_driver:      'vanjski vozač',
        vehicles_driven:      'Vozila',
        average_speed:        'Prosj. km/h',
        max_speed:            'Najv. km/h',
        speeding:             'Prekoračenja',
        stops:                'Zaustavljanja',
        consumption:          'Potrošnja',
        odometer:             'Brojač (km)',
        odometer_tracker:     'brojač uređaja',
    },
    day: {
        pick:          'Dan…',
        previous:      'Prethodni dan',
        next:          'Sljedeći dan',
        clear:         'Natrag na razdoblje',
        legend:        'Podebljani su dani kada je vozilo vozilo.',
        view_trips:    'Vožnje',
        view_day:      'Dan',
        start:         'Početak',
        end:           'Kraj',
        drives:        'vožnji: {count}',
        stops:         'zaustavljanja: {count}',
        driving:       'vožnja {duration}',
        parked_before: 'Stoji od prije',
        still_parked:  'Još stoji',
        still_driving: 'Još vozi',
        speed_chart:   'Brzina kroz dan',
        no_data:       'Na taj dan nema podataka.',
        no_driving:    'Toga dana vozilo nije vozilo.',
        moving:        'vožnja',
        standing:      'stoji',
    },
    parameter: {
        parameters:  'Parametri',
        id:          'ID',
        name:        'Naziv',
        group:       'Skupina',
        count:       'Br. zapisa',
        last_value:  'Zadnja vrijednost',
        last_seen:   'Zadnji put viđeno',
        unknown:     'nepoznat parametar',
        filter:      'Filtriraj po nazivu ili ID-u …',
        empty:       'Za ovaj uređaj još nema zabilježenih parametara.',
        group_obd:   'OBD',
        group_oem:   'OEM',
        group_other: 'Uređaj',
        vehicle_hint: 'OBD i OEM parametri podaci su iz vozila — zbog njih ovo prikupljanje i postoji.',
        hide_empty_slots:   'Sakrij prazna mjesta',
        no_sensor:          'nema senzora',
        hidden_empty_slots: 'Skrivenih praznih mjesta: {count}',
    },
    record: {
        records:     'Zapisi',
        ts:          'Vrijeme uređaja',
        received_at: 'Primljeno',
        priority:    'Prioritet',
        event:       'Događaj',
        periodic:    'periodični',
        position:    'Položaj',
        speed:       'Brzina',
        io:          'IO elementi',
        io_id:       'ID',
        io_name:     'Naziv',
        io_size:     'Bajtova',
        io_value:    'Vrijednost',
        io_hex:      'Hex',
        io_text:     'Tekst',
        io_empty:    'Zapis nema IO elemenata.',
        load_older:  'Učitaj starije',
        no_more:     'Nema više starijih zapisa',
        empty:       'Uređaj još nije poslao nijedan zapis.',
        newest_first: 'Najnoviji na vrhu',
        asleep_hint: 'Uređaj spava — GNSS prijamnik je isključen pa nema određivanja položaja.',
    },
    priority: {
        low:   'niska',
        high:  'visoka',
        panic: 'panika',
    },
    packet: {
        packets:      'Sirovi paketi',
        codec:        'Kodek',
        codec_8:      'Codec 8',
        codec_8e:     'Codec 8E',
        record_count: 'Zapisa',
        state:        'Dekodirano',
        decoded:      'Dekodirano',
        failed:       'Greška',
        remote_addr:  'Adresa uređaja',
        received_at:  'Primljeno',
        raw_hex:      'Sirovi bajtovi',
        show_hex:     'Prikaži bajtove',
        hide_hex:     'Sakrij bajtove',
        empty:        'Za ovaj uređaj nema spremljenih paketa.',
        bytes:        '{count} B',
    },
    gauges: {
        show: 'Instrumenti',
        hide: 'Sakrij instrumente',
        title:        'Instrumenti',
        as_of:        'Zadnje vrijednosti · {when}',
        no_data:      'Uređaj još nije poslao podatke',
        ignition_on:  'Paljenje uključeno',
        ignition_off: 'Paljenje isključeno',
        speed:        'Brzina',
        rpm:          'Okretaji',
        coolant:      'Rashladna tekućina',
        fuel:         'Gorivo',
        load:         'Opterećenje',
        voltage:      'Akumulator',
        soc:          'Baterija',
        charging:     'Puni se',
        not_charging: 'Nije priključen',
        battery_temp: 'Temp. baterije',
        hv_voltage:   'Napon baterije',
        hv_current:   'Struja baterije',
        soh:          'Zdravlje baterije',
        range:        'Domet',
        energy:       'Energija u bateriji',
        consumption:  'Potrošnja',
        lifetime_use: 'Ukupna potrošnja',
        fuel_litres:  'Gorivo (OEM)',
        until_service: 'Do servisa',
        odometer_oem: 'Kilometraža vozila (OEM)',
        odometer_gps: 'Kilometraža uređaja (GPS)',
        hint:         'Sivi pokazivač znači da vozilo taj podatak ne šalje.',
        stale_hint:   'Zatamnjeni pokazivač prikazuje zadnju vrijednost prije nego što je vozilo prestalo slati taj podatak (npr. nakon isključivanja paljenja).',
        stale_at:     'u {time}',
        stale_title:  'Zadnja vrijednost u {time} — vozilo taj podatak trenutačno ne šalje.',

        style_analogue: 'Pokazivači',
        style_digital:  'Zaslon',
        drivetrain_ev:  'Elektrika',
        drivetrain_ice: 'Unutarnje izgaranje',
        vin:            'VIN',
        trip:           'put',
        range_of:       'domet {value}',
        power_derived:  'Snaga (V × A)',
        pack:           'HV baterija',
        charging_state: 'Punjenje',
        intake_air:     'Usisni zrak',
        fault_codes:    'Greške (DTC)',
        movement:       'Kretanje',
        moving:         'U pokretu',
        stopped:        'Miruje',
        tracker:        'Uređaj',
        gsm:            'GSM',
        satellites:     'sat.',
    },
    speeding: {
        check:        'Ograničenja',
        found:        'Prekoračenja: {count}',
        none:         'Nema prekoračenja',
        matched:      '{matched} od {total} točaka spojeno na cestu s upisanim ograničenjem',
        limit_was:    'ograničenje {limit}',
        unnamed_road: 'neimenovana cesta',
        unavailable:  'Ograničenja nije bilo moguće dohvatiti — ništa nije označeno.',
        disclaimer:   'Informativno: GNSS trag spojen na kartu zajednice, nije dokaz.',
    },
    trip: {
        found:             'Vožnje: {count}',
        none:              'U odabranom razdoblju nema vožnji',
        stop_label:        'Vožnja završava nakon',
        out:               'tamo',
        back:              'natrag',
        open:              'u tijeku',
        max_speed:         'najviše {speed} km/h',
        stops:             'zaustavljanja: {count}',
        name_start:        'Imenuj polazište',
        name_end:          'Imenuj odredište',
        names_unavailable: 'Imena mjesta nije bilo moguće dohvatiti s karte — prikazane su koordinate.',
        truncated:         'Razdoblje sadrži više točaka nego što ih je pročitano: najstarije vožnje nedostaju.',
        rule:              'Vožnja završava kada vozilo stoji najmanje {minutes} min.',
        presentation:      'Prikaz',
        open_replay:       'Vožnja još nije završena (vozilo mora stajati {minutes} min). Reproducira se do {time}.',
    },
    replay: {
        play:           'Reproduciraj vožnju',
        pause:          'Pauza',
        restart:        'Na početak',
        speed:          'Brzina reprodukcije',
        follow:         'Prati vozilo',
        scrubber:       'Reprodukcija vožnje',
        stop:           'zaustavljanje {duration}',
        badge:          'Reprodukcija',
        playing:        'Reproducira',
        drive_of:       'vožnja {n} od {total}',
        continue:       'Nastavi na sljedeću vožnju',
        next_drive:     'Sljedeća vožnja',
        previous_drive: 'Prethodna vožnja',
        loading_next:   'Učitavam sljedeću vožnju…',
    },
    zone: {
        title:                 'Područja',
        subtitle:              'Isti krugovi po kojima se imenuju vožnje ujedno su područja na koja su vezana pravila alarma.',
        add:                   'Novo područje',
        empty:                 'Još nema nijednog područja.',
        map_empty:             'Nacrtaj prvo područje da se prikaže na karti.',
        edit_help:             'Klikni na kartu za središte, povuci rub za polumjer.',
        edit_on_map:           'Uredi na karti',
        name:                  'Ime',
        name_too_long:         'Ime je predugo.',
        kind:                  'Vrsta',
        kind_place:            'Mjesto',
        kind_depot:            'Skladište',
        kind_customer:         'Kupac',
        kind_restricted:       'Zabranjeno područje',
        radius:                'Polumjer',
        radius_range:          'Polumjer mora biti između 25 i 2000 m.',
        note:                  'Napomena',
        note_too_long:         'Napomena je preduga.',
        saved:                 'Područje je spremljeno.',
        created:               'Područje je dodano.',
        save_failed:           'Područje nije bilo moguće spremiti.',
        delete:                'Izbriši područje',
        delete_confirm:        'Izbrisati područje „{name}“? Vožnje će ponovno nositi ime naselja.',
        delete_forced_confirm: 'Da ga ipak izbrišem i uklonim iz njih?',
        deleted:               'Područje je izbrisano.',
        delete_failed:         'Područje nije bilo moguće izbrisati.',
        in_use:                'Područje nije moguće izbrisati jer ga koriste pravila.',
        used_by:               'Područje koriste pravila: {names}.',
        no_rules:              'Nijedno pravilo ne koristi ovo područje.',
        no_zones:              'Bez područja',
        search:                'Pretraži po imenu ili napomeni …',
        clear_search:          'Očisti pretragu',
        match_count:           '{n} od {total}',
        no_match:              'Nijedno područje ne odgovara upitu »{q}«.',
        on_map_count:          '{n} na karti',
        on_map:                'Na karti: {name}',
        show_on_map:           'Prikaži na karti',
        hide_on_map:           'Sakrij s karte',
        show_all:              'Prikaži sve na karti',
        hide_all:              'Sakrij sve',
        map_default_help:      'Na karti su zadano samo područja IT Team. Izbor vrijedi u ovom pregledniku i ne utječe na pravila ni na nazive vožnji.',

        rules:                  'Pravila',
        rules_subtitle:         'Pravila koja napišeš sam: kada konzola javlja ulazak, izlazak, zadržavanje, vožnju izvan radnog vremena ili prebrzu vožnju u području.',
        rules_empty:            'Još nema nijednog pravila.',
        rule_add:               'Novo pravilo',
        rule_edit:              'Uredi pravilo',
        rule_name:              'Ime pravila',
        rule_type:              'Vrsta pravila',
        rule_zones:             'Područja',
        rule_zones_help:        'Pravilo vrijedi za svako odabrano područje. Najviše 50.',
        rule_zones_placeholder: 'Odaberi područja',
        rule_vehicles:          'Vozila',
        rule_vehicles_help:     'Prazno znači sva vozila.',
        rule_saved:             'Pravilo je spremljeno.',
        rule_created:           'Pravilo je dodano.',
        rule_save_failed:       'Pravilo nije bilo moguće spremiti.',
        rule_delete:            'Izbriši pravilo',
        rule_delete_confirm:    'Izbrisati pravilo „{name}“? Otvorena upozorenja tog pravila bit će zatvorena.',
        rule_deleted:           'Pravilo je izbrisano.',
        rule_delete_failed:     'Pravilo nije bilo moguće izbrisati.',
        rule_enabled:           'Pravilo je uključeno.',
        rule_disabled:          'Pravilo je isključeno.',

        type_enter:          'Ulazak u područje',
        type_exit:           'Izlazak iz područja',
        type_dwell:          'Zadržavanje u području',
        type_off_hours:      'Vožnja izvan radnog vremena',
        type_speed:          'Prebrza vožnja u području',
        type_enter_help:     'Javlja kada vozilo uđe u jedno od odabranih područja.',
        type_exit_help:      'Javlja kada vozilo napusti jedno od odabranih područja.',
        type_dwell_help:     'Javlja kada vozilo u području stoji duže od postavljenog vremena.',
        type_off_hours_help: 'Javlja kada vozilo krene izvan radnog vremena. Područja se kod ove vrste ne uzimaju u obzir.',
        type_speed_help:     'Javlja kada vozilo u području prijeđe postavljenu brzinu u dva uzastopna očitanja.',

        severity:              'Ozbiljnost',
        enabled:               'Uključeno',
        disabled:              'Isključeno',
        notify_email:          'Pošalji e-poštu',
        applies:               'Vrijedi',
        working_time:          'Radno vrijeme',
        working_time_required: 'Vožnja izvan radnog vremena treba radno vrijeme.',
        always:                'uvijek',
        from:                  'Od',
        to:                    'Do',
        time_zone:             'Vremenska zona',
        day_1:                 'pon',
        day_2:                 'uto',
        day_3:                 'sri',
        day_4:                 'čet',
        day_5:                 'pet',
        day_6:                 'sub',
        day_7:                 'ned',
        dwell_minutes:         'Zadržavanje',
        dwell_help:            'Od 5 do 1440 minuta.',
        dwell_range:           'Zadržavanje mora biti između 5 i 1440 minuta.',
        speed_kmh:             'Ograničenje',
        speed_help:            'Od 10 do 200 km/h. Vrijedi samo unutar područja.',
        speed_range:           'Ograničenje mora biti između 10 i 200 km/h.',
        zones_required:        'Odaberi barem jedno područje.',
        unit_minutes:          'min',
        all_vehicles:          'Sva vozila',
        n_vehicles:            '{count} vozilo | {count} vozila | {count} vozila',
        states:                'Stanja',
        events:                'Događaji',

        said_enter:     'Ulazak u područje {zone}',
        said_exit:      'Izlazak iz područja {zone}',
        said_dwell:     'Stoji u području {zone} već {value}',
        said_off_hours: 'Vožnja izvan radnog vremena',
        said_speed:     'Prebrza vožnja u području {zone}: {value} km/h',

        builtin_hint: 'Šest ugrađenih provjera o uređaju i vozilu nalazi se u postavkama.',
        builtin_link: 'Otvori postavke upozorenja',
    },
    stop_zone: {
        inside:   'U području {name}',
        outside:  'Nije ni u jednom području',
        checking: 'Provjeravam područja …',
        edit:     'Uredi područje',
        show:     'Prikaži područje',
        add:      'Dodaj područje',
    },
    place: {
        places:         'Imenovana mjesta',
        subtitle:       'Vožnja koja počinje ili završava unutar kruga dobiva ime mjesta umjesto imena naselja. Novo mjesto imenuje se na kraju vožnje, na karti vozila.',
        empty:          'Još nema imenovanih mjesta.',
        add:            'Imenuj mjesto',
        edit:           'Uredi mjesto',
        delete:         'Izbriši mjesto',
        delete_confirm: 'Izbrisati mjesto „{name}“? Vožnje će ponovno nositi ime naselja.',
        deleted:        'Mjesto je izbrisano.',
        delete_failed:  'Mjesto nije bilo moguće izbrisati.',
        dialog_help:    'Svako polazište ili odredište unutar ovog kruga nosit će ovo ime.',
        name:           'Ime',
        name_too_long:  'Ime je predugo.',
        radius:         'Polumjer',
        radius_help:    'Od 25 do 2000 m. Za dvorište ili parkiralište dovoljno je 150 m.',
        radius_range:   'Polumjer mora biti između 25 i 2000 m.',
        position:       'Položaj',
        on_map_hint:    'Isti krugovi ujedno su područja na koja su vezana pravila alarma.',
    },
    map_source: {
        title:              'Izvori karata',
        subtitle:           'Odakle ova konzola dobiva podlogu karte, promet, imena mjesta i ograničenja brzine. Izvori OpenStreetMapa ne trebaju ništa, a izvori TomToma trebaju ključ koji se ovdje upiše jednom i ostaje na poslužitelju.',
        tiles:              'Podloga karte',
        tiles_help:         'Slikovna podloga na kojoj je nacrtana svaka karta u konzoli.',
        traffic:            'Sloj prometa',
        traffic_help:       'Promet uživo, nacrtan preko podloge karte — koja god ona bila. Treba ključ TomToma.',
        place_names:        'Imena mjesta',
        place_names_help:   'Tko odgovara kako se zove mjesto na početku i na kraju vožnje.',
        speed_limits:       'Ograničenja brzine',
        speed_limits_help:  'Odakle dolazi ograničenje s kojim se uspoređuje vožnja.',
        key:                'Ključ TomToma',
        key_placeholder:    'Ključ API-ja TomToma',
        key_stored:         'Ključ je spremljen. Ostavi prazno da ostane.',
        key_server_only:    'Ključ se sprema samo na poslužitelju i nikada se ne vraća pregledniku.',
        key_required:       'Izvor TomToma treba ključ. Upiši ga ili odaberi izvore OpenStreetMapa.',
        test:               'Isprobaj ključ',
        test_ok:            'Ključ radi.',
        test_failed:        'Ključ nije bilo moguće upotrijebiti.',
        remove_key:         'Ukloni ključ',
        remove_key_confirm: 'Ukloniti spremljeni ključ TomToma? Karta, sloj prometa, imena mjesta i ograničenja brzine vraćaju se na OpenStreetMap.',
        source_osm:         'OpenStreetMap',
        source_nominatim:   'OpenStreetMap Nominatim',
        source_tomtom:      'TomTom',
    },
    alert: {
        title:                  'Upozorenja',
        subtitle:               'Što je konzola primijetila na vozilima: uređaj izvan utičnice, prazan akumulator, greške vozila, vozilo koje se ne javlja, roaming i pregrijavanje.',
        open:                   'Otvorena',
        resolved:               'Riješena',
        all:                    'Sva',
        empty:                  'Nema otvorenih upozorenja.',
        empty_resolved:         'Nema riješenih upozorenja.',
        empty_all:              'Nema upozorenja.',
        vehicles:               'Vozilo',
        all_vehicles:           'Sva vozila',
        acknowledge:            'Označi kao viđeno',
        acknowledged:           'Označeno kao viđeno',
        acknowledged_by:        'vidio: {name}',
        opened:                 'Otvoreno {time}',
        resolved_at:            'Riješeno {time}',
        load_older:             'Učitaj starija',
        no_more:                'Nema starijih upozorenja',
        severity_critical:      'Kritično',
        severity_warning:       'Upozorenje',
        severity_info:          'Informacija',
        rule_unplugged:         'Uređaj iskopčan',
        rule_low_voltage:       'Nizak napon akumulatora',
        rule_fault_codes:       'Greške vozila',
        rule_silent:            'Vozilo se ne javlja',
        rule_roaming:           'Roaming',
        rule_overheating:       'Pregrijavanje uređaja',
        rule_unplugged_help:    'Uređaj više ne dobiva napon iz OBD utičnice — netko ga je izvadio iz vozila.',
        rule_low_voltage_help:  'Napon 12 V akumulatora vozila u mirovanju, nakon što vozilo stoji barem pola sata.',
        rule_fault_codes_help:  'Vozilo javlja pohranjene kodove grešaka (OBD).',
        rule_silent_help:       'Uređaj nije poslao ništa dulje nego što je dopušteno.',
        rule_roaming_help:      'SIM kartica je u stranoj mreži, što poskupljuje prijenos podataka.',
        rule_overheating_help:  'Temperatura tiskane pločice uređaja je previsoka.',
        said_unplugged:         'Uređaj je iskopčan iz OBD utičnice',
        said_low_voltage:       'Napon 12 V akumulatora je {value}',
        said_fault_codes:       'Vozilo javlja {count} grešku | Vozilo javlja {count} greške | Vozilo javlja {count} grešaka',
        said_silent:            'Bez podataka već {value}',
        said_roaming:           'Uređaj je u roamingu u stranoj mreži',
        said_overheating:       'Temperatura uređaja {value}',
        unit_hours:             'h',
        settings_title:         'Upozorenja',
        settings_subtitle:      'Što konzola prati na svakom vozilu i tko za to sazna. Pravila se izvode svake minute; e-pošta ide kroz poslužitelj koji se ovdje upiše jednom i ostaje na poslužitelju.',
        quiet_minutes:          'Tiho razdoblje',
        quiet_minutes_help:     'Najmanji razmak između dvije poruke o istom vozilu i istom pravilu, u minutama. Loš spoj koji se okine šest puta na sat tako pošalje jednu poruku.',
        mail_title:             'Obavijesti e-poštom',
        mail_subtitle:          'Jedna poruka po događaju, svim primateljima odjednom i nijednom poimence — adrese putuju u omotnici, a poruka ih ne otkriva.',
        mail_enabled:           'Šalji obavijesti e-poštom',
        mail_incomplete:        'Obavijesti trebaju poslužitelj, pošiljatelja i barem jednog primatelja.',
        smtp_host:              'SMTP poslužitelj',
        smtp_host_placeholder:  'posta.tvrtka.hr',
        smtp_port:              'Vrata',
        tls_mode:               'Zaštita veze',
        tls_mode_help:          'STARTTLS su vrata 587, TLS su vrata 465. Bez zaštite dopušteno je samo do poslužitelja na privatnoj adresi.',
        tls_starttls:           'STARTTLS',
        tls_tls:                'TLS',
        tls_none:               'Bez zaštite',
        smtp_username:          'Korisničko ime',
        smtp_username_help:     'Ostavi prazno ako poslužitelj ne traži prijavu.',
        smtp_password:          'Lozinka',
        password_stored:        'Lozinka je pohranjena. Ostavi prazno da ostane.',
        password_server_only:   'Lozinka se pohranjuje samo na poslužitelju i nikada se ne vraća pregledniku.',
        from_name:              'Ime pošiljatelja',
        from_address:           'Adresa pošiljatelja',
        from_address_placeholder: 'fleet@tvrtka.hr',
        recipients:             'Primatelji',
        recipients_help:        'Najviše 20 adresa. Upiši adresu i pritisni enter ili zalijepi više adresa odjednom.',
        recipients_placeholder: 'adresa@tvrtka.hr',
        language:               'Jezik poruka',
        language_help:          'Jezik na kojem su napisane obavijesti. Onaj tko poruku čita nema konzolu, pa se odlučuje ovdje.',
        time_zone:              'Vremenska zona',
        time_zone_help:         'Zona u kojoj su zapisana sva vremena u porukama.',
        console_url:            'Adresa konzole',
        console_url_help:       'Adresa ove konzole, da poruka može dodati poveznicu na vozilo. Prazno znači bez poveznice.',
        console_url_placeholder: 'https://vozila.tvrtka.hr',
        notify_resolved:        'Javi i kada je upozorenje riješeno',
        test_to:                'Probna poruka na',
        test:                   'Pošalji probnu poruku',
        test_ok:                'Poslužitelj je prihvatio poruku.',
        test_failed:            'Poruku nije bilo moguće poslati.',
        remove_password:        'Ukloni lozinku',
        remove_password_confirm: 'Uklanjam pohranjenu SMTP lozinku? Ako poslužitelj traži prijavu, obavijesti više neće izlaziti.',
        no_line_breaks:         'Ovo polje ne smije sadržavati prijelom retka.',
        bad_address:            'To nije valjana adresa e-pošte.',
        bad_url:                'Adresa mora početi s http:// ili https://.',
        own_rules_hint:         'Vlastita pravila o područjima i radnom vremenu nalaze se na stranici Upozorenja, pod karticom Pravila.',
        own_rules_link:         'Otvori pravila',
        rule_reminder_due_soon: 'Podsjetnik dospijeva',
        rule_reminder_overdue:  'Podsjetnik je dospio',
        reminders_enabled:      'Upozori na podsjetnike vozila',
        reminders_notify_email: 'Pošalji e-poštu i za podsjetnike',
        reminders_help:         'Registracije, osiguranja, tehnički pregledi i servisi upisuju se za svako vozilo posebno.',
        reminders_link:         'Otvori podsjetnike',
    },
    report: {
        reports:                'Izvješća',
        subtitle:               'Automatska izvješća e-poštom: što ide van, kome, koliko često i za koje razdoblje.',
        add:                    'Novo izvješće',
        edit:                   'Uredi izvješće',
        delete:                 'Izbriši izvješće',
        deleted:                'Izvješće je izbrisano.',
        delete_failed:          'Izvješće nije bilo moguće izbrisati.',
        confirm_delete:         'Stvarno izbrisati izvješće »{name}«? S njim se briše i povijest slanja.',
        empty:                  'Nema automatskih izvješća.',
        name:                   'Naziv',
        name_too_long:          'Naziv je predug.',
        type:                   'Vrsta izvješća',
        type_logbook:           'Knjiga vožnji',
        type_fleet_summary:     'Pregled voznog parka',
        type_driver_summary:    'Pregled po vozačima',
        type_alerts_digest:     'Sažetak upozorenja',
        hint_logbook:           'Zbrojevi po vozilima u poruci, a knjiga vožnji za razdoblje u CSV prilogu — ista datoteka koju izvoziš na stranici Vožnje.',
        hint_fleet_summary:     'Što je koje vozilo prevezlo, koliko dugo i s kojim vozačem, te što zahtijeva pažnju.',
        hint_driver_summary:    'Isti brojevi, razvrstani po vozaču svake vožnje umjesto po vozilu.',
        hint_alerts_digest:     'Sva upozorenja koja su se u razdoblju otvorila ili riješila, po vozilima — i što je još otvoreno.',
        accusative_logbook:     'knjigu vožnji',
        accusative_fleet_summary: 'pregled voznog parka',
        accusative_driver_summary: 'pregled po vozačima',
        accusative_alerts_digest: 'sažetak upozorenja',
        frequency:              'Učestalost',
        frequency_daily:        'Dnevno',
        frequency_weekly:       'Tjedno',
        frequency_monthly:      'Mjesečno',
        weekday:                'Dan u tjednu',
        day_of_month:           'Dan u mjesecu',
        day_of_month_help:      'Od 1 do 28, da dan ima svaki mjesec — i veljača.',
        time:                   'Vrijeme',
        time_zone:              'Vremenska zona',
        time_zone_help:         'Vrijeme vrijedi po satu ove zone, uključujući noći kada se sat pomiče.',
        period:                 'Razdoblje',
        period_previous_day:    'Prethodni dan',
        period_previous_week:   'Prethodni tjedan',
        period_previous_month:  'Prethodni mjesec',
        period_month_to_date:   'Od početka mjeseca',
        for_previous_day:       'za prethodni dan',
        for_previous_week:      'za prethodni tjedan (pon–ned)',
        for_previous_month:     'za prethodni mjesec',
        for_month_to_date:      'od početka mjeseca',
        vehicles:               'Vozila',
        all_vehicles:           'Sva vozila',
        vehicles_help:          'Prazno znači sva vozila — i ona dodana poslije.',
        drivers:                'Vozači',
        all_drivers:            'Svi vozači',
        drivers_help:           'Prazno znači sve vozače, uključujući vožnje bez vozača.',
        recipients:             'Primatelji',
        recipients_help:        'Najviše 20 adresa. Upiši adresu i pritisni enter.',
        recipients_placeholder: 'adresa@tvrtka.hr',
        bad_address:            'To nije valjana adresa e-pošte.',
        need_recipient:         'Upiši barem jednog primatelja.',
        language:               'Jezik poruke',
        attach_csv:             'Priloži CSV',
        attach_csv_help:        'Knjiga vožnji ide u prilogu kao CSV datoteka.',
        enabled:                'Uključeno',
        every_day:              'Svaki dan u {time}',
        every_weekday:          'Svaki {day} u {time}',
        every_month:            '{day}. u mjesecu u {time}',
        sentence:               '{when} šaljemo {what} {period} {vehicles} na {recipients}.',
        recipient_count:        '{count} primatelja | {count} primatelja | {count} primatelja',
        for_all_vehicles:       'za sva vozila',
        for_some_vehicles:      'za {count} vozilo | za {count} vozila | za {count} vozila',
        with_csv:               'S CSV prilogom.',
        next_run:               'Sljedeće slanje',
        last_run:               'Zadnje slanje',
        never_run:              'Još nije poslano',
        status_sent:            'Poslano',
        status_failed:          'Nije uspjelo',
        status_skipped_no_mail: 'E-pošta nije postavljena',
        send_now:               'Pošalji sada',
        send_now_confirm:       'Izvješće »{name}« bit će sada poslano primateljima ({count}). Nastaviti?',
        sent:                   'Izvješće je poslano.',
        send_failed:            'Izvješće nije bilo moguće poslati.',
        preview:                'Pregled',
        preview_failed:         'Pregled nije bilo moguće pripremiti.',
        subject:                'Predmet',
        html_part:              'Poruka',
        plain_part:             'Tekst',
        attachment:             'Prilog',
        download:               'Preuzmi',
        no_attachment:          'Ovo izvješće nema priloga.',
        mail_missing:           'E-pošta nije postavljena, pa automatska izvješća neće biti poslana.',
        mail_missing_link:      'Otvori postavke e-pošte',
        runs:                   'Zadnja slanja',
        no_runs:                'Ovo izvješće još nije poslano.',
        settings_card:          'Automatska izvješća',
        settings_hint:          'Knjiga vožnji, pregled voznog parka i sažetak upozorenja e-poštom — dnevno, tjedno ili mjesečno.',
        settings_link:          'Otvori izvješća',
        costs:                  'Troškovi',
        cost_per_km:            'Trošak po km',
        no_costs:               'bez troškova',
        by_category:            'po kategorijama',
        costs_hint:             'Izvješće nosi i troškove razdoblja: ukupno i po kategorijama, a po vozilu još i trošak po km. Razdoblje bez upisanih troškova kaže „bez troškova“.',
    },
    reminder: {
        reminders:              'Podsjetnici',
        subtitle:               'Što treba obaviti na kojem vozilu: registracija, osiguranje, tehnički pregled, vinjeta, servis, gume — po datumu, po kilometrima ili po oboje.',
        add:                    'Dodaj podsjetnik',
        edit:                   'Uredi podsjetnik',
        delete:                 'Izbriši podsjetnik',
        deleted:                'Podsjetnik je izbrisan.',
        delete_failed:          'Podsjetnik nije bilo moguće izbrisati.',
        confirm_delete:         'Doista izbrisati podsjetnik „{title}”?',
        confirm_history:        'S njim se briše i povijest obavljenih radova i troškova. Ako ga želiš samo zaustaviti, radije ga isključi.',
        empty:                  'Nema podsjetnika.',
        vehicle:                'Vozilo',
        all_vehicles:           'Sva vozila',
        type:                   'Vrsta',
        all_types:              'Sve vrste',
        title:                  'Naziv',
        title_help:             'Ako ostaviš prazno, podsjetnik se zove po svojoj vrsti.',
        title_too_long:         'Naziv je predugačak.',
        note:                   'Napomena',
        note_too_long:          'Napomena je predugačka.',
        active:                 'Uključen',
        due_date:               'Dospijeva',
        due_km:                 'Na kilometrima',
        due_help:               'Upiši datum, stanje brojača, motorne sate ili više toga — podsjetnik dospijeva na onom što dođe prije.',
        needs_due:              'Upiši datum, stanje brojača ili motorne sate.',
        clear_date:             'Očisti datum',
        no_odometer:            'Ovo vozilo ne šalje stanje brojača; podsjetnik po kilometrima neće raditi.',
        no_odometer_short:      'Ovo vozilo ne šalje stanje brojača.',
        repeat_months:          'Ponovi za (mjeseci)',
        repeat_km:              'Ponovi za (km)',
        lead_days:              'Upozori prije (dana)',
        lead_km:                'Upozori prije (km)',
        overdue:                'Dospjeli',
        due_soon:               'Uskoro',
        ok:                     'U redu',
        inactive:               'Neaktivni',
        all:                    'Svi',
        due_today:              'dospijeva danas ({date})',
        in_days:                'za {count} dan | za {count} dana | za {count} dana',
        days_ago:               'dospjelo prije {count} dan | dospjelo prije {count} dana | dospjelo prije {count} dana',
        in_km:                  'za {count}',
        km_at:                  'na {at}, sada {now}',
        km_over:                'prekoračeno za {count} (na {at})',
        km_unknown:             'na {at} — vozilo ne šalje stanje brojača',
        every_months:           'svaki {count} mjesec | svaka {count} mjeseca | svakih {count} mjeseci',
        every_km:               'svakih {count}',
        last_done:              'zadnji put {date}',
        at_km:                  'na {at}',
        complete:               'Obavljeno',
        completed:              'Podsjetnik je zabilježen kao obavljen.',
        complete_failed:        'Obavljeni rad nije bilo moguće spremiti.',
        done_at:                'Obavljeno dana',
        done_km:                'Stanje brojača',
        cost:                   'Trošak',
        cost_invalid:           'Upiši iznos, na primjer 186,40.',
        next:                   'Sljedeći put: {next}',
        next_or:                ' odn. ',
        next_at_km:             'na {at}',
        next_none:              'Podsjetnik se nakon toga isključuje i ostaje kao zapis o obavljenom radu.',
        all_for_vehicle:        'Svi podsjetnici vozila',
        said_due_soon:          '{name} — uskoro dospijeva',
        said_overdue:           '{name} — dospjelo',
        type_registration:      'Registracija',
        type_insurance:         'Osiguranje',
        type_inspection:        'Tehnički pregled',
        type_vignette:          'Vinjeta',
        type_service:           'Servis',
        type_tyres:             'Gume',
        type_custom:            'Po mjeri',
        cost_becomes:           'Iznos će biti upisan među troškove kao {category}.',
        completed_with_cost:    'Obavljeno; trošak {amount} je upisan.',
        cost_link:              'Trošak: {amount}',
        open_cost:              'Otvori trošak',
        due_hours:              'Na motornim satima',
        repeat_hours:           'Ponovi za (motorni sati)',
        lead_hours:             'Upozori prije (motorni sati)',
        done_hours:             'Motorni sati',
        no_engine_hours:        'Ovo vozilo ne šalje motorne sate; podsjetnik po motornim satima neće raditi.',
        no_engine_hours_short:  'Ovo vozilo ne šalje motorne sate.',
        hours_unknown:          'na {at} — vozilo ne šalje motorne sate',
    },
    service_case: {
        list_subtitle_operator:    'Od prijave kvara do vozila ponovno u pogonu: svaki nalog, njegov servis i što čeka.',
        list_subtitle_customer:    'Servisni nalozi vaših vozila i dokle su stigli.',
        list_subtitle_workshop:    'Nalozi koje vam je dodijelio operater: termini, ponude, dijelovi i radovi.',
        open_action:               'Prijavi servis',
        report_service:            'Prijavi servis',
        filter_open:               'Otvoreni nalozi',
        filter_all:                'Svi nalozi',
        all_vehicles:              'Sva vozila',
        all_customers:             'Svi klijenti',
        all_workshops:             'Svi servisi',
        empty:                     'Nema servisnih naloga za ovaj odabir.',
        load_older:                'Učitaj starije',
        no_more:                   'Nema starijih naloga.',
        case:                      'Nalog',
        vehicle:                   'Vozilo',
        customer:                  'Klijent',
        workshop:                  'Servis',
        status:                    'Status',
        opened:                    'Otvoren',
        waiting:                   'Čeka',
        waiting_for:               'Čeka {what}',
        out_for:                   'izvan pogona {time}',
        no_workshop:               'Nije dodijeljen',
        days_short:                '{count} d',
        too_long:                  'Tekst je predug',
        fault_codes_too_many:      'Najviše {count} kodova',
        odometer_invalid:          'Kilometraža mora biti između 0 i 10.000.000',
        slots_at_least_one:        'Potreban je barem jedan termin',
        slots_too_many:            'Najviše {count} termina',
        status_reported:           'Prijavljeno',
        status_scheduled:          'Termin potvrđen',
        status_in_workshop:        'U servisu',
        status_quoted:             'Ponuda poslana',
        status_approved:           'Odobreno',
        status_parts_ordered:      'Dijelovi naručeni',
        status_parts_received:     'Dijelovi stigli',
        status_in_repair:          'Popravak u tijeku',
        status_ready:              'Spremno za preuzimanje',
        status_picked_up:          'Preuzeto',
        status_cancelled:          'Otkazano',
        waiting_appointment:       'termin',
        waiting_approval:          'odobrenje',
        waiting_parts:             'dijelove',
        waiting_repair:            'popravak',
        waiting_pickup:            'preuzimanje',
        trigger:                   'Povod',
        trigger_dtc:               'Kodovi grešaka',
        trigger_reminder:          'Podsjetnik',
        trigger_manual:            'Prijava kvara',
        trigger_renter_report:     'Prijava najmoprimca',
        trigger_return_damage:     'Oštećenje pri povratu',
        step_reported:             'Prijava',
        step_scheduled:            'Termin',
        step_arrived:              'Dolazak',
        step_parts:                'Dijelovi',
        step_repair:               'Radovi',
        step_ready:                'Gotovo',
        step_picked_up:            'Preuzeto',
        subtitle:                  'Od alarma do preuzimanja',
        odometer:                  'Kilometraža',
        downtime:                  'Izvan pogona',
        next_step:                 'Sljedeći korak',
        your_turn:                 'Na potezu ste vi.',
        whose_turn:                'Na potezu: {party}',
        reader_note:               'Imate pravo čitanja: korake poduzima administrator.',
        on_behalf:                 'U ime druge strane',
        offered_slots:             'Ponuđeni termini',
        extra_waiting:             'Dodatni radovi čekaju odluku',
        approve:                   'Odobri',
        reject:                    'Odbij',
        party_operator:            'Operater',
        party_customer:            'Klijent',
        party_workshop:            'Servis',
        turn_assign:               'Dodjela servisa',
        turn_slots:                'Prijedlog termina',
        turn_confirm:              'Potvrda termina',
        turn_arrival:              'Dolazak vozila u servis',
        turn_quote:                'Dijagnoza i ponuda',
        turn_approval:             'Odobrenje ponude',
        turn_extra:                'Odluka o dodatnim radovima',
        turn_parts_or_repair:      'Narudžba dijelova ili početak radova',
        turn_delivery:             'Isporuka dijelova',
        turn_start:                'Početak radova',
        turn_repair:               'Radovi u tijeku',
        turn_pickup:               'Preuzimanje vozila',
        turn_done:                 'Vozilo je ponovno u pogonu',
        turn_cancelled:            'Nalog je otkazan',
        hint_scheduled:            'Dogovoreni termin: {slot}',
        hint_quoted:               'Ponuda servisa: {total} bez PDV-a.',
        hint_quoted_hidden:        'Servis je poslao ponudu na odobrenje operateru.',
        hint_rejected:             'Prethodna ponuda je odbijena: {reason}',
        action_assign:             'Dodijeli servis',
        action_reassign:           'Promijeni servis',
        action_propose_slots:      'Predloži termine',
        action_confirm_slot:       'Potvrdi termin',
        action_intake:             'Zaprimi vozilo',
        action_send_quote:         'Pošalji ponudu',
        action_send_quote_again:   'Pošalji novu ponudu',
        action_approve_quote:      'Odobri ponudu',
        action_reject_quote:       'Odbij ponudu',
        action_extra_work:         'Predloži dodatne radove',
        action_decide_extra:       'Odluči o dodatnim radovima',
        action_order_parts:        'Naruči dijelove',
        action_start_repair:       'Započni radove',
        action_complete_repair:    'Radovi završeni',
        action_pickup:             'Potvrdi preuzimanje',
        action_cancel:             'Otkaži nalog',
        complete_blocked_extra:    'Dodatni radovi još čekaju odluku operatera.',
        complete_blocked_parts:    'Dijelovi su još na putu: označite ih zaprimljenima ili otkažite narudžbu.',
        step_failed:               'Korak nije uspio',
        assigned:                  'Servis je dodijeljen',
        slots_sent:                'Termini su poslani',
        slot_confirmed:            'Termin je potvrđen',
        intake_done:               'Vozilo je zaprimljeno',
        quote_sent:                'Ponuda je poslana',
        quote_approved_done:       'Ponuda je odobrena',
        quote_rejected_done:       'Ponuda je odbijena',
        extra_sent:                'Dodatni radovi su predloženi',
        extra_approved_done:       'Dodatni radovi su odobreni',
        extra_rejected_done:       'Dodatni radovi su odbijeni',
        repair_started:            'Radovi su započeti',
        completed:                 'Radovi su završeni; vozilo je spremno za preuzimanje',
        picked_up_done:            'Preuzimanje je potvrđeno; nalog je zatvoren',
        cancelled_done:            'Nalog je otkazan',
        confirm_approve:           'Odobriti ponudu od {total} bez PDV-a? Servis tada može naručiti dijelove i započeti radove.',
        confirm_pickup:            'Potvrditi da je vozilo preuzeto? Nalog se zatvara i mjerenje vremena izvan pogona završava.',
        reject_quote_help:         'Servis će poslati novu ponudu. Napišite što treba promijeniti.',
        reject_extra:              'Odbij dodatne radove',
        cancel_help:               'Otkazani nalog se zatvara; vozilo se vraća bez popravka. Za novi problem otvorite novi nalog.',
        reason:                    'Razlog',
        reason_help:               'Neobavezno. Vidi ga i druga strana.',
        pick_workshop:             'Odaberite servis',
        no_workshops:              'Nema aktivnih servisa. Dodajte ga u Organizacijama.',
        reassign_note:             'Novi servis počinje dogovor o terminu iznova: termini prethodnog servisa se brišu.',
        slots_help:                'Ponudite jedan ili više termina (do 10). Klijent potvrđuje jedan od njih.',
        slot_start:                'Od',
        slot_end:                  'Do',
        slot_end_after:            'Kraj mora biti nakon početka',
        slot_too_long:             'Termin može trajati najviše 7 dana',
        add_slot:                  'Dodaj termin',
        send_slots:                'Pošalji termine',
        slots_offered:             'Predložen {count} termin | Predložena {count} termina | Predloženo {count} termina',
        note:                      'Napomena',
        intake_help:               'Vozilo je stiglo u servis: kada, s kojom kilometražom i u kakvom stanju.',
        intake_walk_in:            'Vozilo je stiglo bez dogovorenog termina (šlep, dolazak bez najave) — prijem preskače termin.',
        intake_at:                 'Vrijeme prijema',
        intake_future:             'Prijem ne može biti u budućnosti',
        intake_note_placeholder:   'Vidljiva oštećenja, gorivo, oprema u vozilu …',
        photos:                    'Fotografije',
        photos_help:               'JPEG, PNG, WebP ili PDF, do 10 MB po datoteci.',
        photos_pick:               'Odaberite fotografije',
        photos_drop:               'ili ih povucite ovamo',
        photos_kept:               '{count} fotografija je već učitana | {count} fotografije su već učitane | {count} fotografija je već učitano',
        photos_uploaded:           'Učitana {count} fotografija | Učitane {count} fotografije | Učitano {count} fotografija',
        photo_failed:              'Fotografiju nije bilo moguće učitati',
        photo_missing:             'Fotografija nije dostupna',
        quote_help:                'Dijelovi i rad koje servis fakturira operateru. Iznosi su bez PDV-a; ukupni iznos izračunava sustav.',
        quote_note:                'Napomena uz ponudu',
        quote_rejected_title:      'Prethodna ponuda je odbijena',
        send_quote:                'Pošalji ponudu',
        extra_help:                'Rad koji ste pronašli izvan odobrene ponude. Operater ga odobrava ili odbija; fotografija pomaže odluci.',
        extra_description:         'Opis',
        extra_amount:              'Iznos bez PDV-a',
        extra_photo_help:          'Fotografija dokazuje potrebu za radom (npr. istrošeni disk).',
        send_extra:                'Pošalji na odobrenje',
        complete_help:             'Radovi su gotovi i vozilo je spremno za preuzimanje. Opišite što je napravljeno.',
        complete_notes:            'Što je napravljeno',
        open_title:                'Prijava servisa',
        open_help:                 'Otvara servisni nalog za vozilo. Operater dodjeljuje servis.',
        open_submit:               'Otvori nalog',
        open_failed:               'Nalog nije otvoren',
        opened_done:               'Otvoren je nalog {code}',
        pick_vehicle:              'Odaberite vozilo',
        title:                     'Naslov',
        title_placeholder:         'npr. Lampica motora, buka kočnica',
        description:               'Opis problema',
        fault_codes:               'Kodovi grešaka',
        fault_codes_help:          'Kodovi očitani dijagnostikom, odvojeni zarezom (P0301). Uređaj šalje samo njihov broj.',
        fault_code_invalid:        'Kod grešaka: slova, brojke i crtica, 2–12 znakova',
        odometer_help:             'Prazno: zadnja kilometraža s uređaja.',
        in_service:                'Vozilo ostaje u pogonu do dolaska u servis',
        in_service_help:           'Tada se vrijeme izvan pogona mjeri od prijema u servis, a ne od sada.',
        from_alert:                'Iz upozorenja: {what} — {vehicle}',
        from_reminder:             'Iz podsjetnika: {what} — {vehicle}',
        open_existing:             'Otvori {code}',
        open_case:                 'Otvori nalog',
        open_from_alert:           'Otvori servisni nalog',
        open_from_reminder:        'Otvori servisni nalog',
        overview:                  'Sažetak naloga',
        coordinator:               'Koordinator',
        appointment:               'Termin',
        out_of_service:            'Izvan pogona od',
        still_in_service:          'Vozilo je u pogonu do prijema',
        odometer_opened:           'Kilometraža pri prijavi',
        odometer_intake:           'Kilometraža pri prijemu',
        picked_up:                 'Preuzeto',
        sum_parts:                 'Dijelovi',
        sum_labour:                'Rad',
        sum_extra:                 'Dodatni radovi',
        sum_total:                 'Ukupno bez PDV-a',
        invoicing_note:            '{operator} naplaćuje klijentu; servis fakturira operateru.',
        prices_hidden:             'Cijene radova dogovaraju operater i servis; račun dobivate od operatera.',
        work:                      'Dijagnoza i radovi',
        reported_problem:          'Prijavljeni problem',
        intake:                    'Prijem u servis',
        quote_version:             'Ponuda v{version}',
        quote_approved:            'Odobrena',
        quote_rejected:            'Odbijena',
        quote_waiting:             'Čeka odobrenje',
        quote_sent_by:             'Poslao {name}, {at}',
        quote_approved_by:         'odobrio {name}, {at}',
        extra_work:                'Dodatni radovi',
        extra_proposed:            'Čeka odluku',
        extra_approved:            'Odobreno',
        extra_rejected:            'Odbijeno',
        completion:                'Završetak radova',
        thread:                    'Zajednička komunikacija',
        thread_subtitle:           'Operater, klijent i servis na jednom mjestu.',
        thread_empty:              'Još nema poruka.',
        message_placeholder:       'Napišite poruku … (Ctrl+Enter šalje)',
        attach:                    'Priloži fotografije',
        send:                      'Pošalji',
        gallery:                   'Foto dokumentacija',
        gallery_count:             '{count} datoteka | {count} datoteke | {count} datoteka',
        gallery_empty:             'Još nema fotografija.',
        add_photos:                'Dodaj fotografije',
        upload:                    'Učitaj',
        open_original:             'Otvori izvornik',
        photo_report:              'Prijava',
        photo_intake:              'Prijem',
        photo_diagnosis:           'Dijagnoza',
        photo_extra_work:          'Dodatni radovi',
        photo_completion:          'Završetak',
        photo_message:             'Poruka',
        trail:                     'Trag aktivnosti',
        trail_empty:               'Još nema aktivnosti.',
        event_opened:              'Nalog otvoren ({trigger})',
        event_workshop_assigned:   'Dodijeljen servis {name}',
        event_workshop_reassigned: 'Servis promijenjen: {name}',
        event_slots_proposed:      'Predložen {count} termin | Predložena {count} termina | Predloženo {count} termina',
        event_slot_confirmed:      'Potvrđen termin {slot}',
        event_intake:              'Vozilo zaprimljeno u servis',
        event_intake_km:           'Vozilo zaprimljeno u servis ({km})',
        event_quote_sent:          'Poslana ponuda v{version}',
        event_quote_approved:      'Ponuda v{version} odobrena',
        event_quote_rejected:      'Ponuda v{version} odbijena',
        event_extra_work_proposed: 'Predloženi dodatni radovi',
        event_extra_work_approved: 'Dodatni radovi odobreni',
        event_extra_work_rejected: 'Dodatni radovi odbijeni',
        event_part_order_created:  'Kreirana narudžba dijelova',
        event_part_order_updated:  'Narudžba dijelova izmijenjena',
        event_part_order_moved:    'Narudžba dijelova: {status}',
        event_repair_started:      'Radovi započeti',
        event_repair_completed:    'Radovi završeni',
        event_picked_up:           'Vozilo preuzeto',
        event_cancelled:           'Nalog otkazan',
        event_photo_added:         'Dodana fotografija',
        event_photos_added:        'Dodana {count} fotografija | Dodane {count} fotografije | Dodano {count} fotografija',
        error_illegal:             'Ovaj korak u trenutnom stanju naloga nije moguć — nalog se u međuvremenu promijenio i učitan je ponovno.',
        error_changed:             'Nalog je u međuvremenu promijenio netko drugi — učitan je ponovno. Pogledajte promjenu i pokušajte još jednom.',
        error_exists:              'Vozilo već ima otvoren servisni nalog. Novi problem dodajte u njega (poruka ili dodatni radovi).',
        error_not_found:           'Nalog nije pronađen ili vam nije dostupan.',
    },
    line_items: {
        kind:             'Vrsta',
        kind_part:        'Dio',
        kind_labour:      'Rad',
        description:      'Opis',
        part_number:      'Šifra dijela',
        quantity:         'Količina',
        hours:            'Sati',
        unit_price:       'Cijena',
        line_total:       'Iznos',
        total:            'Ukupno bez PDV-a',
        add:              'Dodaj stavku',
        add_part:         'Dodaj dio',
        add_labour:       'Dodaj rad',
        quantity_invalid: 'Količina mora biti veća od nule (npr. 1 ili 1,5)',
        price_invalid:    'Iznos u eurima, najviše dvije decimale (npr. 45,90)',
        at_least_one:     'Potrebna je barem jedna stavka',
        too_many:         'Najviše {count} stavki',
    },
    part_order: {
        orders:                   'Narudžbe dijelova',
        subtitle_operator:        'Narudžbe servisa po nalozima: unesite ih u svoj sustav, potvrdite s brojem narudžbe i otpremite.',
        subtitle_workshop:        'Dijelovi koje ste naručili od operatera za svoje naloge.',
        of_case:                  'Narudžbe dijelova',
        none_on_case:             'Za ovaj nalog još nema narudžbi dijelova.',
        empty:                    'Nema narudžbi u ovom popisu.',
        filter_active:            'Aktivne',
        filter_closed:            'Završene',
        closed_capped:            'Prikazano je zadnjih {count} završenih narudžbi.',
        status_draft:             'Nacrt',
        status_submitted:         'Poslano',
        status_confirmed:         'Potvrđeno',
        status_shipped:           'Otpremljeno',
        status_received:          'Zaprimljeno',
        status_cancelled:         'Otkazano',
        at_created:               'Kreirano',
        at_submitted:             'Poslano',
        at_confirmed:             'Potvrđeno',
        at_shipped:               'Otpremljeno',
        at_received:              'Zaprimljeno',
        at_cancelled:             'Otkazano',
        add:                      'Nova narudžba dijelova',
        edit:                     'Uredi narudžbu',
        dialog_help:              'Dijelovi koje naručujete od operatera za ovaj nalog. Cijene upisujete sami dok katalog nije povezan.',
        note:                     'Napomena',
        save_draft:               'Spremi nacrt',
        save_and_submit:          'Spremi i pošalji',
        draft_saved:              'Nacrt je spremljen',
        submit:                   'Pošalji',
        submitted:                'Narudžba je poslana',
        confirm:                  'Potvrdi',
        confirmed:                'Narudžba je potvrđena',
        external_ref:             'Broj narudžbe u vašem sustavu',
        external_ref_help:        'Neobavezno — veza s narudžbom u ERP-u.',
        external_ref_short:       'Br. {ref}',
        ship:                     'Otpremi',
        shipped:                  'Narudžba je otpremljena',
        receive:                  'Zaprimi',
        received:                 'Dijelovi su zaprimljeni',
        cancel:                   'Otkaži narudžbu',
        cancelled:                'Narudžba je otkazana',
        confirm_cancel_draft:     'Otkazati ovaj nacrt narudžbe?',
        confirm_cancel_submitted: 'Otkazati poslanu narudžbu? Servis će to vidjeti na nalogu.',
        step_failed:              'Korak narudžbe nije uspio',
        error_changed:            'Narudžbu je u međuvremenu promijenio netko drugi — učitana je ponovno.',
    },
    out_of_service: {
        title:               'Vozila izvan pogona',
        subtitle:            'Koja vozila stoje i zašto, i koliko treba da se vozilo vrati u pogon.',
        window_days:         '{count} d',
        out_now:             'Izvan pogona sada',
        open_cases:          'Otvoreni nalozi',
        opened:              'Otvoreno',
        closed:              'Vraćeno u pogon',
        in_window:           'u odabranom razdoblju',
        cancelled_note:      'i {count} otkazan | i {count} otkazana | i {count} otkazanih',
        avg_downtime:        'Prosječno do pogona',
        measured:            'iz {count} naloga | iz {count} naloga | iz {count} naloga',
        waiting_appointment: 'Termin',
        waiting_approval:    'Odobrenje',
        waiting_parts:       'Dijelovi',
        waiting_repair:      'Popravak',
        waiting_pickup:      'Preuzimanje',
        vehicles:            'Vozila koja stoje',
        vehicles_subtitle:   'Najdulje izvan pogona prvo.',
        none_out:            'Nijedno vozilo trenutno nije izvan pogona.',
        downtime:            'Izvan pogona',
        since:               'Od {at}',
        by_customer:         'Po klijentima',
        by_workshop:         'Po servisima',
        name:                'Naziv',
        col_out:             'Stoji',
        col_open:            'Otvoreno',
        col_opened:          'Novih',
        col_closed:          'Vraćeno',
        col_avg:             'Prosjek',
        no_rows:             'Nema podataka u razdoblju.',
    },
    units: {
        kmh:        'km/h',
        meters:     'm',
        degrees:    '°',
        celsius:    '°C',
        percent:    '%',
        volt:       'V',
        km:         'km',
        ampere:     'A',
        kwh:        'kWh',
        kwh_100km:  'kWh/100 km',
        litre:      'l',
        kw:         'kW',
        rpm:        'o/min',

        rpm_x1000:  '× 1000 o/min',
    },
    /*
     * The installation guide (`views/guide/`). Prose only: Configurator's own labels, the
     * AVL ids and the wiki addresses are the same in every language and live in
     * `libs/guide.ts`; this deployment's address comes from GET /install-info. The console's
     * own labels (menu entries, buttons, states) are passed in from their own keys, so the
     * guide always names them the way the screen does.
     */
    guide: {
        title:   'Upute za ugradnju',
        heading: 'Postavljanje Teltonika FMC003',
        lede:    'Kako novi uređaj FMC003 pripremiti da šalje podatke u ovu konzolu: od SIM kartice i programa Teltonika Configurator do provjere prve vožnje. Nazivi polja navedeni su onako kako ih prikazuje Configurator, na engleskom.',
        values: {
            title:         'Vrijednosti koje se upisuju',
            domain:        'Poslužitelj (Domain)',
            port:          'Port',
            protocol:      'Protocol',
            data_protocol: 'Data protocol',
            unknown:       'Ova konzola ne zna javnu adresu na koju uređaji šalju podatke. Prije početka zatražite adresu i port od administratora.',
            unknown_admin: 'Adresa se postavlja u okruženju servisa stanic-api, varijablama TRACKER_PUBLIC_HOST i TRACKER_PUBLIC_PORT. Dok nisu postavljene, upute adresu ne prikazuju.',
            ask:           'od administratora',
        },
        col: {
            field:     'Polje',
            value:     'Vrijednost',
            note:      'Napomena',
            on_stop:   'Na stajanju (On Stop)',
            on_moving: 'U vožnji (On Moving)',
            symptom:   'Simptom',
            cause:     'Najčešći uzrok',
        },
        value: {
            per_operator: 'prema operateru',
            default:      'zadano',
        },
        before: {
            title:    'Prije početka',
            device:   'Uređaj FMC003 i njegov IMEI (15 znamenki, na naljepnici uređaja i na kutiji).',
            sim:      'Micro-SIM kartica s paketom podataka i isključenim PIN-om. Od operatera trebate naziv APN-a, a za neke operatere i korisničko ime i lozinku.',
            computer: 'Računalo s Windowsima, najnoviji {configurator} i Teltonikini USB upravljački programi (COM port drivers), te micro-USB kabel. Umjesto kabela može se koristiti i Bluetooth.',
            account:  'Administratorski račun u konzoli.',
        },
        add: {
            title:      'Dodajte vozilo u konzolu',
            intro:      'Poslužitelj prihvaća samo uređaje čiji je IMEI upisan u konzolu. Uređaj koji nije upisan bit će odbijen već pri prvom spajanju, čak i ako je sve ostalo ispravno podešeno.',
            open:       'U konzoli otvorite {vehicles} i odaberite {add}.',
            fill:       'Upišite IMEI, naziv vozila i registarsku oznaku. Za električna i hibridna vozila odaberite i pogon, kako bi konzola prikazala odgovarajuće instrumente.',
            save:       'Spremite. Poslužitelj preuzima novi IMEI unutar 30 sekundi.',
            imei_title: 'IMEI je jedina zaštita.',
            imei_body:  'Poslužitelj uređaj prepoznaje isključivo po IMEI-ju, zato IMEI ne dijelite izvan tima. Uređaj koji se više ne koristi izbrišite u konzoli: time mu se odmah zabranjuje spajanje.',
            reader:     'Prijavljeni ste kao čitatelj: vozilo može dodati samo administrator. Pošaljite mu IMEI, naziv vozila i registarsku oznaku.',
        },
        sim: {
            title: 'Umetnite SIM karticu',
            power: 'SIM umećite i vadite samo dok je uređaj isključen, izvan OBD priključka. Umetanje pod naponom može oštetiti uređaj.',
            pin:   'PIN na SIM kartici mora biti isključen. Ako to nije moguće, PIN se upisuje u Configuratoru.',
        },
        connect: {
            title:        'Spojite uređaj na Configurator',
            usb_title:    'USB kabelom',
            usb_drivers:  'Instalirajte Teltonikine COM port drivere (samo Windows x64).',
            usb_connect:  'Spojite FMC003 micro-USB kabelom i pokrenite Configurator. Uređaj se pojavljuje na popisu, odaberite ga.',
            bt_title:     'Bluetoothom',
            bt_on:        'Bluetooth je na FMC003 uključen prema zadanim postavkama. Uređaj se oglašava kao {prefix} i zadnjih sedam znamenki IMEI-ja.',
            bt_pair:      'Uparite ga s računalom. Zadani PIN za uparivanje je {pin}.',
            before_title: 'Prije promjena',
            backup:       'Kliknite {load}, a zatim {save} da biste sačuvali izvornu konfiguraciju.',
            firmware:     'Ako Configurator ponudi novi firmware, ažurirajte ga ({update}). Za čitanje OEM podataka iz vozila potreban je firmware {version} ili noviji.',
        },
        gprs: {
            title:         'GPRS: APN i poslužitelj',
            apn:           'Naziv APN-a za podatkovni paket SIM kartice.',
            apn_login:     'Većina operatera ih ne traži, tada ostaju prazna.',
            domain:        'Javna adresa poslužitelja za prijem podataka.',
            protocol:      'UDP poslužitelj ne prima.',
            tls:           'Isključeno.',
            second_server: 'Rezervni poslužitelj se ne koristi.',
            ack:           'Poslužitelj potvrđuje primljene zapise na standardni Teltonikin način.',
        },
        system: {
            title:             'System: protokol i spavanje',
            data_protocol:     'Obavezno. Samo Codec 8 Extended prenosi parametre s oznakom većom od 255, npr. kilometražu vozila (389).',
            sleep:             'Uređaj ostaje spojen na mrežu, a GPS se gasi dok vozilo miruje. Konzola takvo vozilo prikazuje kao „{asleep}”.',
            without_ts:        'Zapisi bez točnog vremena ne šalju se.',
            static_navigation: 'Uklanja „skakanje” položaja dok vozilo stoji.',
            sources:           'Za električna vozila vidi napomenu u koraku 07.',
        },
        acquisition: {
            title:   'Data Acquisition: koliko često se šalje',
            path:    'Configurator › Data Acquisition › Home (isto ponoviti za Roaming, ako vozilo ide u inozemstvo)',
            intro:   'Konzola vozilo prikazuje kao „{offline}” ako od uređaja ništa ne stigne {minutes} min. Zato razdoblje slanja u mirovanju mora biti kraće od toga.',
            derived: 'Razdoblje na stajanju ({period} s) izračunato je iz postavki ove konzole: trećina tog vremena, zaokružena naniže na cijelu minutu, najviše 300 s.',
            outro:   'Ove vrijednosti daju glatku liniju vožnje na karti i prikaz uživo s kašnjenjem od desetak sekundi, a vozilo koje stoji šalje oko {per_day} zapisa dnevno umjesto nekoliko tisuća.',
        },
        obd: {
            title:         'OBD II i OEM podaci iz vozila',
            feature:       'Za vozila s motorom s unutarnjim izgaranjem.',
            feature_ev:    'Za električna vozila. Standardni OBD upiti na električnom vozilu vraćaju besmislene vrijednosti (npr. temperatura rashladne tekućine), a ovaj način koristi samo OEM parametre proizvođača.',
            vin:           'Ako VIN ne stigne, upišite ga ručno (Manual).',
            params_title:  'Parametri koje konzola koristi',
            params_intro:  'U kartici {io} (i u OBD/OEM popisima) uključite sljedeće parametre, s prioritetom {low}. Konzola sprema sve što uređaj pošalje, ali ove prikazuje na instrumentima, u vožnjama i u upozorenjima.',
            params_outro:  'Koji od OEM parametara vozilo stvarno šalje ovisi o marki i modelu. Parametar koji vozilo ne podržava jednostavno neće stići, i konzola ga tada ne prikazuje.',
        },
        param: {
            ignition:         'paljenje',
            movement:         'kretanje',
            external_voltage: 'akumulator',
            dtc_count:        'broj grešaka',
            fault_codes:      'kodovi grešaka',
            oem_mileage:      'km vozila',
        },
        install: {
            title: 'Spremite i ugradite',
            save:  'Kliknite {save}, a zatim {reboot}.',
            file:  'Sačuvajte novu konfiguraciju i u datoteku ({save_file}). Istu datoteku možete kasnije učitati na sljedeće uređaje ({load_file} pa {save}), a zatim samo provjeriti APN.',
            plug:  'Uređaj utaknite u OBD priključak vozila. Mora biti postavljen tako da ne smeta vozaču. Ako je priključak na nezgodnom mjestu, koristite OBD produžni kabel.',
        },
        check: {
            title:      'Provjera u konzoli',
            online:     'U konzoli otvorite {vehicles} i vozilo. Unutar nekoliko minuta stanje se mijenja u „{online}”, a „{last_record}” pokazuje trenutno vrijeme.',
            parameters: 'U kartici {parameters} provjerite stižu li paljenje (239), napon akumulatora (66) i, ako vozilo to podržava, VIN (256) i kilometraža vozila (389).',
            drive:      'Odvezite kratku probnu vožnju. Na stranici {map} vozilo treba biti prikazano u vožnji, a nakon završetka vožnja se pojavljuje na stranici {trips} i na stranici vozila.',
            ok_title:   'Sve je u redu kad…',
            ok_body:    'vozilo na stranici {map} ima ispravan položaj, u vožnji se pomiče svakih desetak sekundi, a nakon parkiranja prelazi u stanje „{stopped}” odnosno „{asleep}”.',
        },
        trouble: {
            title:                'Ako nešto ne radi',
            never_seen:           'Vozilo ostaje „{never_seen}”',
            never_seen_cause:     'IMEI nije upisan u konzolu ili je upisan pogrešno; pogrešan APN; PIN na SIM kartici nije isključen; umjesto TCP-a odabran je UDP ili je port pogrešan.',
            offline_parked:       '„{offline}” dok vozilo stoji',
            offline_parked_cause: 'Razdoblje slanja na stajanju (On Stop) dulje je od {minutes} min, ili je odabran način spavanja u kojem se uređaj odspaja s mreže (Deep Sleep, Ultra Deep Sleep).',
            no_oem:               'Nema kilometraže vozila ni podataka baterije',
            no_oem_cause:         'Uključite OEM parametre u kartici I/O i ažurirajte firmware. Za električna vozila postavite OBD Feature na Non-Compliant.',
            impossible:           'Instrumenti pokazuju nemoguće vrijednosti',
            impossible_cause:     'Električno vozilo s OBD (Auto): standardni motorni parametri nemaju smisla. Prebacite na Non-Compliant.',
            km:                   'Kilometri nisu točni',
            km_cause:             'Vozilo ne šalje OEM kilometražu (389), pa konzola koristi GPS brojač uređaja (16), koji počinje od nule pri ugradnji.',
        },
        sources: {
            title:       'Izvori',
            intro:       'Nazivi polja i zadane vrijednosti prema Teltonikinoj dokumentaciji:',
            first_start: 'FMC003 First Start',
            gprs:        'GPRS settings',
            system:      'System settings',
            acquisition: 'Data acquisition',
            obd:         'OBD II settings',
            parameters:  'popis parametara',
            note:        'Izgled Configuratora može se malo razlikovati ovisno o verziji programa i firmwarea.',
        },
    },
}
